import React from 'react';

import Alert from 'ui/Alert';
import Link from 'ui/Link';

import { websiteLinkTo } from '../../utils/routes';
import { useCurrentUser } from '../../utils/user';

// TODO: Rename component to ...Alert
const CustomerApproachedSankeysLimitBanner: React.FC = () => {
  const { user } = useCurrentUser();

  if (
    user &&
    user.has_active_subscription &&
    user.remaining_nr_of_sankeys === 1
  ) {
    return (
      <Alert
        status="info"
        title={
          <>
            Consider{' '}
            <Link
              href={websiteLinkTo('/subscriptions/')}
              variant="subtle"
              isExternal
            >
              upgrading your plan
            </Link>{' '}
            to create more diagrams
          </>
        }
      >
        You are currently using {user.created_nr_of_sankeys} of your{' '}
        {user.allowed_nr_of_sankeys} allowed diagram slots.
      </Alert>
    );
  }

  return null;
};

export default CustomerApproachedSankeysLimitBanner;
